import React, { forwardRef, ReactNode } from 'react';
import { Accordion as ChakraAccordion, AccordionProps } from '@chakra-ui/react';

interface Props extends Omit<AccordionProps, `css`> {
  children: ReactNode;
}

export const Accordion = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraAccordion allowToggle ref={ref} {...props}>
        {children}
      </ChakraAccordion>
    );
  }
);
export type { Props as AccordionProps };
